import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, branch, renderNothing, withState } from 'recompose';
import { isPristine, submit } from 'redux-form';
import { injectIntl } from 'react-intl';
import { get, isEmpty } from 'lodash';

import createValidator from 'shared/utils/formValidator';
import { fetchCaseDataForm } from 'modules/appointmentInfo/actions/fetchCaseDataForm';
import { updateCaseDataForm, clearCaseDataForm } from 'modules/appointmentInfo/actions/updateCaseDataForm';
import { getUpdateCurrentAppointmentPermissions } from 'modules/appointmentsManagement/selectors/appointments';
import { isClosedAppointment } from 'modules/appointmentInfo/selectors/currentAppointment';
import {
  getCaseSummaryInputConfig,
  getFormInitialValues,
  getValidationConfig,
} from 'modules/appointmentInfo/selectors/caseData';

import CaseDataForm from './CaseDataForm';

const CASE_DATA_FORM = 'CASE_DATA_FORM';
const submitForm = () => submit(CASE_DATA_FORM);

const mapStateToProps = state => {
  const form = CASE_DATA_FORM;

  return ({
    form,
    formConfig: getCaseSummaryInputConfig(state),
    initialValues: getFormInitialValues(state),
    validationConfig: getValidationConfig(state),
    isPristine: isPristine(form)(state),
    updateRequestStatus: state.appointmentInfo.caseData.caseDataFormUpdateStatus,
    isClosed: isClosedAppointment(state),
    canEditCaseData: getUpdateCurrentAppointmentPermissions(state).canEditCaseSummary,
  });
};

export default compose(
  injectIntl,
  connect(mapStateToProps, {
    submitForm,
    fetchCaseDataForm,
    updateCaseDataForm,
    clearCaseDataForm,
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchCaseDataForm();
    },
    componentWillUnmount() {
      this.props.clearCaseDataForm();
    },
  }),
  branch(({ formConfig, initialValues, isClosed }) => isEmpty(formConfig) || (isEmpty(initialValues) && isClosed), renderNothing),
  withState('editModeEnabled', 'setEditMode', ({ initialValues }) => isEmpty(initialValues)),
  withHandlers({
    validate: ({ validationConfig, intl }) => (formData) => {
      return createValidator(
        validationConfig.rules,
        validationConfig.errorMessages,
        validationConfig.attributeLabels,
      )(formData, { intl });
    },
    onSubmit: ({ updateCaseDataForm, formConfig, setEditMode }) => (formData) => {
      const result = formConfig.map(item => ({
        path: item.path,
        value: get(formData, item.path, item.value),
      }));

      return updateCaseDataForm(result, formData)
        .then(() => setEditMode(false));
    },
  }),
)(CaseDataForm);
